import { render, staticRenderFns } from "./FaqQuestionAnswer.vue?vue&type=template&id=4a9281ec&"
import script from "./FaqQuestionAnswer.vue?vue&type=script&lang=js&"
export * from "./FaqQuestionAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a9281ec')) {
      api.createRecord('4a9281ec', component.options)
    } else {
      api.reload('4a9281ec', component.options)
    }
    module.hot.accept("./FaqQuestionAnswer.vue?vue&type=template&id=4a9281ec&", function () {
      api.rerender('4a9281ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/faq/FaqQuestionAnswer.vue"
export default component.exports